import { Reducer } from "redux";

import { TabSessionStorageReAuthDispatchTypes } from "../constants/TabSessionStorage";
import { TabSessionDataReAuthResponse } from "../models/api/TabSessionStorage";
import { TabSessionDataReAuthDispatchTypes } from "../models/dispatchTypes/TabSessionStorage";

export const initialState: TabSessionDataReAuthResponse = {
  loading: false,
  response: null as any,
  error: null,
};

const TabSessionReAuthReducer: Reducer<
  TabSessionDataReAuthResponse,
  TabSessionDataReAuthDispatchTypes
> = (state = initialState, action: any) => {
  switch (action.type) {
    case TabSessionStorageReAuthDispatchTypes.SET_TAB_DATA_RE_AUTH_INVOKE: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case TabSessionStorageReAuthDispatchTypes.SET_TAB_DATA_RE_AUTH_SUCCESS:
      return { ...state, response: action.response, loading: false, error: {} };
    case TabSessionStorageReAuthDispatchTypes.SET_TAB_DATA_RE_AUTH_RESET:
      return initialState;
    default:
      return state;
  }
};

export default TabSessionReAuthReducer;
